var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormBaseElement } from '@unitarius/xbpm-runtime';
import { mapElementClass, omitSpecialProperties } from '../../common/utils/element.utils';
import { InputText } from 'primereact/inputtext';
import { ControlError } from './ControlError';
import * as R from 'ramda';
var toValue = function (val) { return val.replace(',', '.').replace(/\s/g, ''); };
var MoneyControl = /** @class */ (function (_super) {
    __extends(MoneyControl, _super);
    function MoneyControl(props) {
        var _this = _super.call(this, props) || this;
        _this.minMaxValue = function (val) {
            var max = R.path(['def', 'frontOptions', 'max'], _this.state);
            var min = R.path(['def', 'frontOptions', 'min'], _this.state);
            var valueNum = +toValue((val || 0).toString());
            if (!max && !min) {
                return valueNum;
            }
            return valueNum < min ? min : valueNum > max ? max : valueNum;
        };
        _this.formatValue = function (nextVal, prevVal) {
            if (prevVal === void 0) { prevVal = _this.state.inputValue; }
            if (!R.isNil(nextVal) && ("" + nextVal).toLowerCase().indexOf('e') !== -1) {
                return { value: +nextVal, maskedText: '', inputValue: "" + nextVal };
            }
            var text = R.isNil(nextVal) ? '' : toValue(nextVal.toString());
            var inputValue = R.isNil(prevVal) ? '' : toValue(prevVal.toString());
            var numberChar = text.length - 1;
            var char = text[numberChar];
            var change = false;
            if (inputValue.length > text.length) {
                inputValue = text;
            }
            else {
                var firstNull = numberChar === 1 && text[0] === '0';
                var startsWithZeros = firstNull && char === '0';
                var maxLengthProp = R.path(['def', 'frontOptions', 'maxLength'], _this.state);
                var maxLength = !maxLengthProp ||
                    (!/[.]/.test(text) && inputValue.length < maxLengthProp) ||
                    (/[.]/.test(text) && text.indexOf('.') <= maxLengthProp);
                var hasFract = R.path(['def', 'frontOptions', 'hasFract'], _this.state);
                change =
                    ((/[0-9]/.test(char) && (!/[.]/.test(text) || text.indexOf('.') > text.length - 4)) ||
                        (hasFract && /[.]/.test(char) && !/[.]/.test(text.substring(0, text.length - 1)) && text.length > 1)) &&
                        !startsWithZeros &&
                        maxLength;
                if (change) {
                    if (firstNull && /[0-9]/.test(char)) {
                        inputValue = char;
                    }
                    else {
                        inputValue = text;
                    }
                }
            }
            inputValue = inputValue.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
            var value = toValue(inputValue);
            return { value: !!value ? +value : null, inputValue: inputValue };
        };
        _this.onChange = function (target, val) {
            var next = _this.formatValue(val);
            _this.handleChange(next.value);
            var type = target.actionButton;
            if (type) {
                _this.props.onEvent({ type: type, target: target });
            }
            _this.setState({ inputValue: next.inputValue }, _this.forceUpdate);
        };
        _this.state = __assign(__assign({}, _this.state), { inputValue: _this.formatValue(_this.value).inputValue });
        return _this;
    }
    MoneyControl.prototype.onBlur = function (evt, target) {
        var value = this.value;
        var minMaxValue = this.minMaxValue(value);
        if (this.value !== minMaxValue) {
            value = minMaxValue;
            this.onChange(target, minMaxValue);
        }
        this.handleBlur(evt);
        this.onChange(target, value);
    };
    MoneyControl.prototype.elementRender = function (def) {
        var _this = this;
        var _a = def.frontOptions, hint = _a.hint, label = _a.label, placeholder = _a.placeholder, restOptions = __rest(_a, ["hint", "label", "placeholder"]);
        var printLabel = label || def.label;
        var value = parseInt(this.value, 10);
        return def.hidden ? null : (React.createElement("div", { className: mapElementClass(restOptions) },
            React.createElement("label", { htmlFor: def.id, title: printLabel }, printLabel),
            React.createElement(InputText, __assign({}, omitSpecialProperties(restOptions), { ref: function (ref) {
                    if (ref) {
                        ref['element'].setAttribute('field-code', def.code);
                    }
                }, keyfilter: "money", key: def.id, id: def.id, disabled: def.disabled, readOnly: def.readonly, onChange: function (evt) { return _this.onChange(def, evt.target.value); }, onBlur: function (evt) { return _this.onBlur(evt, def); }, onFocus: this.handleFocus, value: isNaN(value) ? '' : this.state.inputValue, tooltip: hint, placeholder: placeholder || null })),
            React.createElement(ControlError, { error: this.error, touched: this.touched })));
    };
    return MoneyControl;
}(FormBaseElement));
export { MoneyControl };
//# sourceMappingURL=Money.js.map